<template>
  <div>
    <div
      class="cover"
      :style="{ backgroundImage: 'url(' + img_api + pageData.bannerImg + ')' }"
    >
      <div class="front">
        <div class="title">
          <div class="big_title">
            {{ pageData.firstTitle }}
          </div>
          <div class="transparent_title">{{ pageData.secondTitle }}</div>
        </div>
        <div class="des">
          {{ pageData.des }}
        </div>
      </div>
    </div>
    <div class="bread_box">
      <div class="crumb">
        <span class="your_position">您所在的位置:</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/trade' }"
            >{{ pageData.firstTitle }}{{ pageData.secondTitle }}
          </el-breadcrumb-item>
          <el-breadcrumb-item>详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="news_page">
      <div class="head">
        <div class="return_button" @click="goBack">返回列表页</div>
      </div>
      <div class="news_content">
        <div>
          <div class="big_img_box"       @mouseenter="isShow = true"
      @mouseleave="isShow = false">
            <img class="big_img" :src="img_api + img" alt="" />
            <transition name="fade">
              <div v-show="isShow">
                <div class="right_btn" @click="next_img">
                  <img src="../assets/img/right_btn.png" alt="" />
                </div>
                <div class="left_btn" @click="return_img">
                  <img src="../assets/img/left_btn.png" alt="" />
                </div>
                <div class="sum">
                  {{ tabIndex }} /{{ productData.imageList.length }}
                </div>
              </div>
            </transition>
          </div>

          <div class="small_img_box">
            <div
              class="small_img"
              v-for="item in productData.imageList"
              :key="item.id"
              @click="toBig(item)"
              :class="item.id == tabIndex ? ' blue_border' : ''"
            >
              <img :src="img_api + item.url" alt="" />
            </div>
          </div>
        </div>
        <div>
          <div class="news_data">
            <div class="news_type">型号：{{ productData.englishName }}</div>
            <div class="news_title">{{ productData.name }}</div>
          </div>
          <p class="content_front">
            {{ productData.details }}
          </p>
        </div>
      </div>
    </div>
    <div class="content_bottom">
      <div class="tab_content">
        <div class="tabs">
          <div
            v-for="item in tabsList"
            :key="item.id"
            @click="toTab(item.id)"
            :class="item.id == tab2Index ? 'blue' : ''"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="contents" v-html="content"></div>
      </div>
      <button class="btn" @click="toContact">在线咨询&gt;&gt;</button>
    </div>
  </div>
</template>


<script>
import { getGoodDetails } from "@/server/https.js";

export default {
  name: "",

  data() {
    return {
      isShow:false,
      content: "",
      tabIndex: 1,
      tab2Index: 0,
      img: "",
      tabsList: [
        { id: 0, title: "特点与优势" },
        { id: 1, title: "详细参数" },
      ],
      pageData: {
        firstTitle: "",
        secondTitle: "",
        bannerImg: "",
        des: "",
      },
      productData: {},
      img_api: "https://www.gdyuanwo.com/gdyuanwo/",
      api: "http://192.168.31.41:7070/gpa/gpwx",
    };
  },
  beforeMount() {
    getGoodDetails({ goodId: this.$route.query.goodId }).then((res) => {
      this.productData = res.data.body.gpGood;
      this.img = res.data.body.gpGood.imageList[0].url;
      this.content = res.data.body.gpGood.brief;
    });

    var setI = setInterval(() => {
      if (this.$store.state.headList != "") {
        var headList = this.$store.state.headList;
        headList.map((item) => {
          if (item.sort == 3) {
            let Name = item.name;
            this.pageData.firstTitle = Name.slice(0, -2);
            this.pageData.secondTitle = Name.substr(-2);
            this.pageData.bannerImg = item.image;
            this.pageData.des = item.details;
          }
        });
        clearInterval(setI);
      }
    }, 200);
  },
  methods: {
    //返回上一层
    goBack() {
      this.$router.go(-1); // 返回上一个路由
    },
    //点击缩略图
    toBig(item) {
      this.tabIndex = item.id;
      this.img = item.url;
    },
    //下一张图片
    next_img() {
      if (this.tabIndex < this.productData.imageList.length) {
        this.tabIndex++;
        let object1 = this.productData.imageList.find(
          (item) => item.id == this.tabIndex
        );
        this.img = object1.url;
      }
    },
    //上一张图片
    return_img() {
      if (this.tabIndex > 1) {
        this.tabIndex--;
        let object1 = this.productData.imageList.find(
          (item) => item.id == this.tabIndex
        );
        this.img = object1.url;
      }
    },
    toTab(index) {
      this.tab2Index = index;
      if (index == 0) {
        this.content = this.productData.brief;
      } else {
        this.content = this.productData.param;
      }
    },
    toContact() {
      this.$router.push({
        name: "Contact",
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true;
    next(0);
  },
};
</script>

<style scoped>
.cover {
  overflow: hidden;
  height: 355px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.front {
  margin-top: 72px;
  margin-left: 240px;
}

.title {
  display: flex;
}

.big_title {
  font-size: 68px;
  font-weight: bold;
  color: #ffffff;
}

.transparent_title {
  font-size: 68px;
  font-weight: bold;
  color: rgba(255, 255, 255, 0);
  color: rgba(255, 255, 255, 0);
  -webkit-text-stroke: 1px #ffffff;
  text-stroke: 1px #ffffff;
}

.des {
  font-size: 24px;
  color: #ffffff;
}

.bread_box {
  overflow: hidden;
  height: 60px;
  background-color: #f7f8fa;
}

.crumb {
  display: flex;
  margin-top: 23px;
  margin-left: 140px;
}

.your_position {
  line-height: 1;
  font-size: 14px;
  font-weight: 400;
  color: #13489d;
  margin-right: 5px;
}

.news_page {
  width: 62.5rem;
  margin: auto;
}

.news_type {
  font-size: 16px;
  font-weight: 400;
  color: #999999;
  display: flex;
  align-items: center;
}

.looks_num {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  margin-left: 40px;
}

.head {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding-bottom: 20px;
}

.news_title {
  font-weight: 500;
  color: #333333;
  margin: 20px;
  margin-left: 0;
  font-size: 30px;
  font-weight: bold;
}

.news_data {
  border-bottom: 1px solid #999999;
  margin-left: 20px;
}

.return_button {
  width: 140px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #5877ba;
  font-size: 18px;
  font-weight: 400;
  color: #13489d;
  line-height: 48px;
  text-align: center;
  position: absolute;
  cursor: pointer;
}

.news_content {
  margin-top: 4rem;
  display: flex;
}

.big_img_box {
  position: relative;
  display: flex;
  width: 550px;
  height: 400px;
}

.big_img {
  width: 100%;
  height: 100%;
}

.small_img_box {
  display: flex;
  margin-top: 20px;
  width: 100%;
  height: 60px;
  /* background-color: rgb(249, 144, 144); */
}

.small_img {
  margin-right: 10px;
  width: 50px;
  height: 50px;
  border: 2px solid #eeeeee;
}

.blue {
  color: #13489d;
  border-bottom: 4px solid #13489d;
}

.blue_border {
  border: 2px solid #13489d;
}

.small_img img {
  width: 100%;
  height: 100%;
}

.right_btn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translate(10px, -30px);
  z-index: 2200;
  width: 35px;
  height: 35px;
}

.right_btn img {
  width: 100%;
  height: 100%;
}

.left_btn {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(10px, -30px);
  z-index: 2200;
  width: 35px;
  height: 35px;
}

.left_btn img {
  width: 100%;
  height: 100%;
}

.sum {
  position: absolute;
  bottom: 10px;
  right: 20px;
  width: 48px;
  height: 26px;
  background: #000000;
  border-radius: 13px;
  opacity: 0.24;
  text-align: center;
  line-height: 26px;
  color: #ffffff;
}

.content_front {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  text-indent: 25px;
  line-height: 2;
  margin-top: 30px;
  margin-bottom: 100px;
  margin-left: 20px;
}

.content_bottom {
  overflow: hidden;
  position: relative;
  width: 100%;
  margin: 30px auto;
  background-color: #f9f9fd;
  padding-bottom: 100px;
}

.tab_content {
  width: 1000px;
  /* height: 1000px; */
  margin: 30px auto;
  background-color: #fff;
}

.tabs {
  height: 60px;
  line-height: 60px;
  display: flex;
  margin-left: 50px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.tabs div {
  margin-left: 40px;
}

.contents {
  width: 800px;
  height: 100%;
  padding-bottom: 100px;
  margin: 30px auto;
  /* background-color: rgb(238, 108, 108); */
}

.contents img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.btn {
  position: absolute;
  width: 140px;
  height: 48px;
  left: 0;
  right: 0;
  background: #13489d;
  font-weight: 400;
  color: #ffffff;
  margin: auto;
}

.pag {
  float: right;
  margin-bottom: 40px;
  margin-right: 200px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  opacity: 0.5s;
}
</style>
